module.exports = __webpack_public_path__ + "img/not_logged_in.602b0b09.svg";